import { KeyValue, NgStyle }                                                                         from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output }                   from '@angular/core';
import { MatProgressSpinnerModule }                                                                  from '@angular/material/progress-spinner';
import { LetDirective }                                                                              from '@ngrx/component';
import { Store }                                                                                     from '@ngrx/store';
import { Caisse }                                                                                    from '@shared/classes/caisse';
import { User }                                                                                      from '@shared/classes/user';
import { FormuleProductEnum }                                                                        from '@shared/constants/formule-product.enum';
import { TarificationDTO }                                                                           from '@shared/dto/tarificationDTO';
import { EnumOuiNon }                                                                                from '@shared/enums/enumOuiNon';
import { FeatureSpinnerEnum }                                                                        from '@shared/enums/featureSpinner.enum';
import { FormuleEnum }                                                                               from '@shared/enums/formule.enum';
import { ProfilEnum }                                                                                from '@shared/enums/profil.enum';
import { PHASE_DATABASE_TARIFICATION }                                                               from '@shared/enums/tarifications.enum';
import { BehaviorSubject, of, Subject }                                                              from 'rxjs';
import { filter, switchMap, take, tap, withLatestFrom }                                              from 'rxjs/operators';
import { PrecoDefaultComponent }                                                                     from 'src/app/components/main/oav-phase-b/preconisation/components/preco-minimale/preco-default.component';
import { DataTarificationPhaseB }                                                                    from 'src/app/components/main/oav-phase-b/preconisation/dataTarificationPhaseB';
import { ErrorOnFormgroup }                                                                          from 'src/app/shared/errors/errorOnFormgroup';
import { setFormule }                                                                                from 'src/app/shared/ngrx/store/actions/config.actions';
import { StartLoading, StopLoading }                                                                 from 'src/app/shared/ngrx/store/actions/spinner.actions';
import { updateAllDataTarification, updateOneDataTarificationAndCalc }                               from 'src/app/shared/ngrx/store/actions/tarification.action';
import { selectLoadingByKey }                                                                        from 'src/app/shared/ngrx/store/selectors/spinner.selector';
import { selectDatasSurMesurePhaseB, selectDatasTarificationPhaseB, selectPricesTarificationPhaseB } from 'src/app/shared/ngrx/store/selectors/tarif.selector';
import { selectState, selectUser }                                                                   from 'src/app/shared/ngrx/store/selectors/user.selector';
import { ITarificationState }                                                                        from 'src/app/shared/ngrx/store/state/tarification/tarification.state';


import { CheckShowMontantTarificationPhaseBPipe } from 'src/app/shared/pipe/checkShowMontantTarificationPhaseB.pipe';
import { CheckTarifPhaseBPipe }                   from 'src/app/shared/pipe/checkTarifPhaseB.pipe';
import { ColorPipe }                              from 'src/app/shared/pipe/color.pipe';
import { SpinnerPipe }                            from 'src/app/shared/pipe/shared/spinner.pipe';
import { ShowMontantTarificationPhaseBPipe }      from 'src/app/shared/pipe/showMontantTarificationPhaseB.pipe';
import { QueryParams }                            from 'src/app/shared/queryParams/queryParams';
import { UserService }                            from 'src/app/shared/services/user.service';
import { getDatasFromTarification }               from 'src/app/shared/tarfication/tarification.constants';
import { LocalStorageUtil }                       from 'src/app/shared/utils/localStorageUtil';
import { OavTextPrecoComponent }                  from '../../oav/oav-shared/oav-text-preco/oav-text-preco.component';
import { BorderPreconisation }                    from './borderPreconisation';
import { CellsHeader }                            from './cells-header';
import { PrecoLeftColumnComponent }               from './components/preco-left-column/preco-left-column.component';
import { PrecoSurMesureComponent }                from './components/preco-sur-mesure/preco-sur-mesure.component';
import { PRECO_SUR_MESURE }                       from './components/preco-sur-mesure/preco-sur-mesure.constants';

import { PRECO_COLUMN_LEFT, PRECO_CONSEILLEE, PRECO_MINIMALES } from './preconisation-oav.constants';
import { PreconisationOavHelper }                               from './preconisation-oav.helper';


export interface MntsTarif {
  CTT02: number;
  GAV: number,
  GLOBAL: number
  OBSEQUES: number;
  RED02: number
}

@Component ({
              selector:        'app-preconisation-oav',
              templateUrl:     './preconisation-oav.component.html',
              styleUrls:       ['./preconisation-oav.component.scss'],
              changeDetection: ChangeDetectionStrategy.OnPush,
              standalone:      true,
              imports:         [
                LetDirective,
                MatProgressSpinnerModule,
                NgStyle,
                PrecoDefaultComponent,
                OavTextPrecoComponent,
                PrecoSurMesureComponent,
                CheckShowMontantTarificationPhaseBPipe,
                ShowMontantTarificationPhaseBPipe,
                ColorPipe,
                CheckTarifPhaseBPipe,
                PrecoLeftColumnComponent,
                SpinnerPipe,

              ],
              providers:       [],
            })
export class PreconisationOavComponent implements OnInit {
  @Input ()
  caisse: Caisse;

  @Input ()
  user: User;

  @Input ()
  state: EnumOuiNon;

  @Output ()
  next: EventEmitter<boolean>;

  public formuleEnum        = FormuleEnum;
  public formuleProductEnum = FormuleProductEnum;

  public listFormuleMinimales: CellsHeader[];
  public listFormuleConseillee: CellsHeader[];

  protected readonly FormuleEnum = FormuleEnum;

  public listFormuleSurMesure: CellsHeader[];
  public listFormuleSurMesure$: BehaviorSubject<CellsHeader[]>;

  public listLeftColumn: CellsHeader[];
  public listLeftColumn$: BehaviorSubject<CellsHeader[]>;

  public errorOnFormgroup: ErrorOnFormgroup;
  public checkProject$: Subject<DataTarificationPhaseB>;
  public onError$: Subject<ErrorOnFormgroup>;

  public currentFormuleSelected: FormuleEnum;
  public mnts: any;
  public periodicite: KeyValue<string, string>;
  public changeBorder$: BehaviorSubject<BorderPreconisation[]>;

  public selectPricesTarificationPhaseB$  = this._store.select (selectPricesTarificationPhaseB);
  public selectDatasTarificationPhaseB$   = this._store.select (selectDatasTarificationPhaseB);
  public selectLoadingTarificationPhaseB$ = this._store.select (selectLoadingByKey (FeatureSpinnerEnum.TARIFICATION));

  constructor (
    private _store: Store<ITarificationState>,
    private _userService: UserService,
  ) {
    this.next                   = new EventEmitter<boolean> (false);
    this.currentFormuleSelected = FormuleEnum.CONSEILLEE;
    this.changeBorder$          = new BehaviorSubject<BorderPreconisation[]> (this.initDefaultBorder (this.currentFormuleSelected));
    this.listLeftColumn$        = new BehaviorSubject<CellsHeader[]> ([]);
    this.listFormuleSurMesure$  = new BehaviorSubject<CellsHeader[]> ([]);
    this.checkProject$          = new Subject<DataTarificationPhaseB> ();
    this.onError$               = new Subject<ErrorOnFormgroup> ();
    this.errorOnFormgroup       = null;
    this.periodicite            = {
      key:   'MENSUELLE',
      value: 'Mensuelle',
    };

    const _self = this;
    this._store.select (selectState).pipe (
      take (1),
      filter (v => v === EnumOuiNon.OUI),
      tap (v => {
        _self._store.dispatch (StartLoading ({ feature: FeatureSpinnerEnum.TARIFICATION }));
      }),
      switchMap (() => {
        const id             = LocalStorageUtil.getUserId ();
        let tarificationById = of (null);
        if (id) {
          tarificationById = this._userService.getTarification (id.toString ());
        }
        return tarificationById;
      }),
      withLatestFrom (
        this._store.select (selectUser),
        this._store.select (selectDatasTarificationPhaseB),
        this._store.select (selectDatasSurMesurePhaseB),
      ),
    ).subscribe ({
                   next: ([action, user, tarificationPhaseB, tarificationSurMesurePhaseB]: [any, User, DataTarificationPhaseB[], DataTarificationPhaseB[]]) => {
                     const tarificationFromDatabase = action as TarificationDTO;
                     const formule                  = tarificationFromDatabase?.formule || FormuleEnum.CONSEILLEE;
                     const caisse                   = _self.caisse || LocalStorageUtil.getCaisse ();
                     this.initListFormule (formule, user, new QueryParams (), caisse);

                     const dataTarification = getDatasFromTarification (formule, tarificationPhaseB, tarificationSurMesurePhaseB);
                     _self.checkTarification (dataTarification, this.currentFormuleSelected);
                     _self._store.dispatch (StopLoading ({ feature: FeatureSpinnerEnum.TARIFICATION }));
                   },
                 });
  }

  ngOnInit (): void {
    this.mnts = null;
  }


  private checkTarification (dataTarification: DataTarificationPhaseB[], formule: FormuleEnum) {
    const listForInitDatasStore  = PreconisationOavHelper.getListByFormule (
      this.listFormuleMinimales,
      this.listFormuleConseillee,
      this.listFormuleSurMesure,
      formule,
    );
    const dataTarificationPhaseB = PreconisationOavHelper.initDatasTarification (
      this.currentFormuleSelected,
      listForInitDatasStore,
      dataTarification,
    );
    this._store.dispatch (updateAllDataTarification ({
                                                       dataTarificationPhaseB,
                                                       formule,
                                                       phaseDatabaseTarification: PHASE_DATABASE_TARIFICATION.INITIAL,
                                                     }));
  }


  private initListFormule (formule: FormuleEnum, user: User, queryParams: QueryParams, caisse: Caisse) {
    this.listLeftColumn = PreconisationOavHelper.formatFormuleToElligible (FormuleEnum.LEFT, PRECO_COLUMN_LEFT, user, queryParams, ProfilEnum.OAV);

    this.currentFormuleSelected = formule;
    this.changeBorder$.next (this.initDefaultBorder (formule));
    this.listFormuleMinimales = PreconisationOavHelper.formatFormuleToElligible (FormuleEnum.MINIMALE, PRECO_MINIMALES, user, queryParams, ProfilEnum.OAV);

    // pas de 10% pour GMED
    const precoConseillee      = PRECO_CONSEILLEE.filter ((c: CellsHeader) => c.load (caisse));
    this.listFormuleConseillee = PreconisationOavHelper.formatFormuleToElligible (FormuleEnum.CONSEILLEE, precoConseillee, user, queryParams, ProfilEnum.OAV);

    this.listFormuleSurMesure = PreconisationOavHelper.formatFormuleToElligible (FormuleEnum.SUR_MESURE, PRECO_SUR_MESURE, user, queryParams, ProfilEnum.OAV);
    this.listFormuleSurMesure$.next (this.listFormuleSurMesure);

    this.listLeftColumn$.next (this.listLeftColumn);
  }

  private initDefaultBorder (f: string): Array<BorderPreconisation> {
    const ar = new Array<BorderPreconisation> ();
    ar.push (new BorderPreconisation (FormuleEnum.MINIMALE, f === FormuleEnum.MINIMALE));
    ar.push (new BorderPreconisation (FormuleEnum.SUR_MESURE, f === FormuleEnum.SUR_MESURE));
    ar.push (new BorderPreconisation (FormuleEnum.CONSEILLEE, f === FormuleEnum.CONSEILLEE));
    return ar;
  }

  private getFormatDataTarification (checkParametersPreconisation: DataTarificationPhaseB, dataTarificationPhaseB: DataTarificationPhaseB[]): DataTarificationPhaseB[] {
    const listForInitDatasStore =
            PreconisationOavHelper.getListByFormule (this.listFormuleMinimales, this.listFormuleConseillee, this.listFormuleSurMesure, this.currentFormuleSelected);

    const listFormatted = listForInitDatasStore.map (l => {
      const referenceStore = dataTarificationPhaseB.find (d => d.id === l.id);
      let isElligible      = l.isElligible;
      if (referenceStore) {
        isElligible = referenceStore.check;
      }
      return {
        ...l,
        isElligible,
      };
    });
    return PreconisationOavHelper.initDatasTarification (this.currentFormuleSelected, listFormatted, checkParametersPreconisation);
  }

  checkFormule (checkParametersPreconisation: DataTarificationPhaseB, dataTarificationPhaseB: DataTarificationPhaseB[]) {
    this.currentFormuleSelected = checkParametersPreconisation.id as FormuleEnum;
    this.changeBorder$.next (this.initDefaultBorder (checkParametersPreconisation.id));
    this._store.dispatch (setFormule ({ formule: this.currentFormuleSelected }));

    // check error for surmesure if error found - disable input
    this.onError$.next (this.errorOnFormgroup);

    if (!this.errorOnFormgroup.hasError) {
      const dataTarification =
              this.getFormatDataTarification (checkParametersPreconisation, dataTarificationPhaseB);
      this._store.dispatch (updateAllDataTarification ({
                                                         dataTarificationPhaseB:    dataTarification,
                                                         formule:                   this.currentFormuleSelected,
                                                         phaseDatabaseTarification: PHASE_DATABASE_TARIFICATION.UPDATED,
                                                       }));
    }
  }

  checkProducts (checkParametersPreconisation: DataTarificationPhaseB) {
    this.checkProduct (checkParametersPreconisation, this.currentFormuleSelected);
    this.checkProject$.next ({
                               ...checkParametersPreconisation,
                               formuleSelected: this.currentFormuleSelected,
                             });
  }

  checkError (errorOnFormgroup: ErrorOnFormgroup) {
    this.errorOnFormgroup = {
      hasError: false,
      message:  null,
      produit:  null,
      formule:  this.currentFormuleSelected,
    };
    if (this.currentFormuleSelected === FormuleEnum.SUR_MESURE) {
      this.errorOnFormgroup = errorOnFormgroup;
    }
    this.next.emit (!this.errorOnFormgroup.hasError);
  }

  private checkProduct (checkParametersPreconisation: DataTarificationPhaseB, formule: FormuleEnum) {
    const valuesChange = {
      id:      checkParametersPreconisation.id,
      changes: {
        check: checkParametersPreconisation.check,
      },
    };
    this._store.dispatch (updateOneDataTarificationAndCalc ({
                                                              updateCheckParametersPreconisation: valuesChange,
                                                              formule,
                                                              phaseDatabaseTarification:          PHASE_DATABASE_TARIFICATION.UPDATED,
                                                            }));
  }
}
